import { render, staticRenderFns } from "./ExpectedReceived.vue?vue&type=template&id=e7c4c712"
import script from "./ExpectedReceived.vue?vue&type=script&lang=js"
export * from "./ExpectedReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports